export enum BankPaymentFormType {
  DEBIT_CARD = 'debitCard',
  BANK_INFORMATION = 'bankInformation',
}

export enum PaymentRecipientNameChoice {
  Personal = 'personal',
  Business = 'business',
}

export enum BankPaymentAccountType {
  CHECKING = 'checking',
  SAVINGS = 'savings',
}
